var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("ValidationAlert", {
            attrs: { "error-list": _vm.errors.collect("server") },
          }),
          _vm._v(" "),
          _c("legend", [_vm._v("The Company")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.companyName,
                  expression: "formData.companyName",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "company",
                name: "companyName",
                placeholder: "Enter company's name here...",
                required: "",
              },
              domProps: { value: _vm.formData.companyName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "companyName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "company" } },
              [_vm._v("Client company name")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("companyName"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.location,
                  expression: "formData.location",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "location",
                name: "location",
                placeholder: "Enter the location of activities here...",
                required: "",
              },
              domProps: { value: _vm.formData.location },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "location", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "location" } },
              [_vm._v("Location of Activities")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("location"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.activity,
                  expression: "formData.activity",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "activity",
                name: "activity",
                placeholder: "Enter company bio here...",
                required: "",
              },
              domProps: { value: _vm.formData.activity },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "activity", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "activity" } },
              [_vm._v("Company Bio")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("activity"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.tombstone,
                  expression: "formData.tombstone",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "tombstone",
                name: "tombstone",
                placeholder: "Enter tombstone...",
                maxlength: "65",
              },
              domProps: { value: _vm.formData.tombstone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "tombstone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "tombstone" } },
              [_vm._v("Tombstone Company Description")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("tombstone"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "form__character-count" }, [
              _c("small", [
                _vm._v(_vm._s(_vm.tombstoneSize) + " / 65 characters"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form__group" },
            [
              _c("FormControlDatepicker", {
                attrs: { label: "Deal Completed Date" },
                model: {
                  value: _vm.formData.completedAt,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "completedAt", $$v)
                  },
                  expression: "formData.completedAt",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("FormControlDealType", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { name: "dealType" },
            model: {
              value: _vm.formData.dealType,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "dealType", $$v)
              },
              expression: "formData.dealType",
            },
          }),
          _vm._v(" "),
          _vm.formData.dealType === 1 ||
          _vm.formData.dealType === 2 ||
          _vm.formData.dealType === 5
            ? _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.counterpartCompany,
                      expression: "formData.counterpartCompany",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "counterpart",
                    name: "counterpart company",
                    placeholder: "Enter counterpart company's name here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.counterpartCompany },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.formData,
                        "counterpartCompany",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "counterpart" } },
                  [_vm._v("Counterpart company")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("counterpart company"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }